import { LazyLoadImage } from 'react-lazy-load-image-component';

function CanvasPage() {
return (
    <div style={{marginTop: "5em"}}>
    
        <h2 className="text-center">0xDRIP - AI Canvas</h2>
        <div class="text-center flex-center">
            <a class="text-center button" href="/canvas/gallery" style={{marginBottom: "20px"}}>View the Gallery</a>
        </div>
        <div className="container">
        <div className="text-center font-normal">
            <p className="normal centercontent">The Canvas project brings the holder of each canvas the possibility to create your personal collaboration piece from your NFT or images.</p>
        </div>
        </div>
        
        <div className="container font-normal">
            <h4 className="line-under">Step-by-Step</h4>
            <div className="step-wrap">
                <div className="step"><p className="step-header">Step 1</p><p>Own a 0xDRIP - Canvas piece.</p></div>
                <div className="step">
                    <p className="step-header">Step 2</p>
                <p>Go to <a href="https://drip-tools.vercel.app/canvas">the drip-tools form</a></p>
                <p>Connect your wallet holding the Canvas you own.</p>
                <p>Fill in the form, selecting the canvas you want to use, <br></br>the image you want to use and how much DRIP you want.</p>
                </div>
                <div className="step"><p className="step-header">Step 3</p>
                <p>The AI will now start rendering.</p>
                <p>The Team will quality check the render, and possibly make improvements to make the DRIP work for all images.</p>
                <p>Your Canvas image will then get updated and be displayed in your wallet!</p></div>
                <p className="bold">Any canvas can be submit again to be recustomized, just empty canvases will take priority in the workflow.</p>
            </div>
        </div>
        <div className="container flex-space-between">
            
        <LazyLoadImage
            className="step-image"
            alt="Step 1 example"
            src="/canvas.png" />
        <LazyLoadImage
            className="step-image"
            alt="Step 2 example"
            src="/step2.png" />
        <LazyLoadImage
            className="step-image"
            alt="Step 3 example"
            src="/step3.png" />
        </div>
        <div className="text-center font-normal">
            <p className="normal" style={{lineHeight: "2em"}}>You can view the original of any dripped canvas by going to <br></br><a className="normal" href="https://www.dripnft.org/canvasitem/8">https://www.dripnft.org/canvasitem/8</a> <br></br>where the number is the no. of the canvas</p>
        </div>
        <h3 className="text-center">Submission link</h3>
        <div className="container flex-center">
        <a href="https://drip-tools.vercel.app/canvas" className="text-center">Canvas submission form on drip-tools</a>
        </div>
        <h3 className="text-center">Where to get your Canvas?</h3>
        <div className="container flex-center">
        <ul>
            <li><a href="https://magiceden.io/marketplace/dripcanvas" >MagicEden</a></li>
            <li><a href="https://opensea.io/collection/0xdrip-canvas-collection" >OpenSea</a></li>
            <li><a href="https://coralcube.io/collection/dripcanvas" >CoralCube</a></li>
        </ul>
        </div>
        
        <h3 className="text-center">FAQ</h3>
        <div className="container font-normal">
            <p>Q: Does it burn my Canvas when I submit?</p>
            <p style={{marginBottom: "2em"}}>A: No, we just update it once the render is ready.</p>
            <p>Q: I didn't like my final render, what can I do?</p>
            <p style={{marginBottom: "2em"}}>A: You can resubmit a different image, some images just have conflicts with the style from the AI, sorry.</p>
            <p>Q: Will my NFT change after I have it rendered to a DRIP version?</p>
            <p style={{marginBottom: "2em"}}>A: It will stay the same until you submit a new request to that same canvas</p>
        </div>
    </div>
)
}
export default CanvasPage